import { type ThunkDispatch } from '@reduxjs/toolkit';
import { modifiedSearchFilter } from '@repo/advanced-filters';
import { criteriaService } from 'crm-atoms/services';

export const saveCriteria = (
  criteria: any,
) => async (
  dispatch: ThunkDispatch<any, any, any>,
) => {
  if (criteria && criteria?.conditions?.length > 0) {
    const serverReadableCriteria = modifiedSearchFilter({
      levels: criteria?.conditions || [],
      comparator: criteria?.baseComparator || 'AND',
    }, [], []);

    const response = await dispatch(criteriaService.endpoints.saveCriteria.initiate(serverReadableCriteria));
    if (response.error) throw response.error;

    const savedCriteriaId = response?.data?.criteria_group?.id;
    return savedCriteriaId ? parseInt(savedCriteriaId, 10) : undefined;
  }
  return undefined;
};
